import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("circle", {
  class: "spinner__path",
  cx: "25",
  cy: "25",
  r: "20",
  fill: "none",
  "stroke-width": "7"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass({ spinner: true, 'spinner--white': $props.isWhite }),
    viewBox: "0 0 50 50"
  }, _hoisted_2, 2))
}